import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { NgbConfig } from '@ng-bootstrap/ng-bootstrap';
import { AkitaNgDevtools } from '@datorama/akita-ngdevtools';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AkitaNgRouterStoreModule } from '@datorama/akita-ng-router-store';
import { FooterComponent } from './footer/footer.component';
import { PitchPlaylistModule } from './shared/pitch-playlist/pitch-playlist.module';
import { HeaderComponent } from './header/header.component';
import { PitchServicesModule } from './shared/pitch-services/pitch-services.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FeatureFlagQuery, FeatureFlagService, FeatureFlagStore } from 'src/app/shared/feature-flag/state';
import { FeatureFlagModule } from 'src/app/shared/feature-flag/feature-flag.module';
import { PitchApiService } from './pitch-api.service';
import { BrowserResizeService } from 'src/app/shared/browser/resize.service';
import { NgxFaviconModule } from 'ngx-favicon';
import { AvailableCustomFavicons, customFavicons } from './favicon.config';
import { FaviconService, NGX_FAVICON_CONFIG } from './favicon.service';
import { PitchTitleService } from './pitch-title.service';
import { PitchPageMetaService } from './pitch-page-meta.service';

const faviconsConfig = {
  faviconElementId: 'favicon',
  defaultUrl: '/pitch/assets/favicon.ico',
  custom: customFavicons
};

@NgModule({
  declarations: [AppComponent, HeaderComponent, FooterComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    PitchPlaylistModule.forRoot(),
    PitchServicesModule.forRoot(),
    FeatureFlagModule,
    AppRoutingModule,
    AkitaNgRouterStoreModule,
    environment.production ? [] : [AkitaNgDevtools],
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    NgxFaviconModule.forRoot<AvailableCustomFavicons>(faviconsConfig)
  ],
  providers: [
    {
      provide: 'isPitch',
      useValue: true
    },
    {
      provide: 'ApiService',
      useClass: PitchApiService
    },
    FeatureFlagStore,
    FeatureFlagQuery,
    FeatureFlagService,
    BrowserResizeService,
    FeatureFlagService,
    FaviconService,
    PitchTitleService,
    PitchPageMetaService,
    { provide: NGX_FAVICON_CONFIG, useValue: faviconsConfig }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(ngbConfig: NgbConfig) {
    // Disable ng-bootstrap animations to fix popover visibility issues in Angular 13+
    ngbConfig.animation = false;
  }
}
